import { render, staticRenderFns } from "./FormAssemblyWidget.vue?vue&type=template&id=81eee944&scoped=true"
import script from "./FormAssemblyWidget.vue?vue&type=script&lang=js"
export * from "./FormAssemblyWidget.vue?vue&type=script&lang=js"
import style0 from "./FormAssemblyWidget.vue?vue&type=style&index=0&id=81eee944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81eee944",
  null
  
)

export default component.exports